const enableExternalScripts = {
  eagerLoadGtm() {
    const $gtmScripts = document.querySelectorAll('script[data-id="gtm"]');

    for (let i = 0; i < $gtmScripts.length; i += 1) {
      const $old = $gtmScripts[i];

      const $new = document.createElement('script');
      $new.innerHTML = $gtmScripts[i].innerHTML;

      $old.replaceWith($new);
    }
  },

  startOnUserInteraction() {
    const enableScripts = () => {
      window.removeEventListener('mousemove', enableScripts);
      window.removeEventListener('keydown', enableScripts);
      window.removeEventListener('touchstart', enableScripts);
      window.removeEventListener('scroll', enableScripts);

      const $inlineScripts = document.querySelectorAll('script[type="text/plain"]');
      for (let i = 0; i < $inlineScripts.length; i += 1) {
        const $old = $inlineScripts[i];

        const $new = document.createElement('script');
        $new.innerHTML = $inlineScripts[i].innerHTML;

        $old.replaceWith($new);
      }

      const $externalScripts = document.querySelectorAll('script[data-src]');
      for (let i = 0; i < $externalScripts.length; i += 1) {
        const $old = $externalScripts[i];

        const $new = document.createElement('script');
        $new.src = $externalScripts[i].getAttribute('data-src');

        $old.replaceWith($new);
      }
    };

    window.addEventListener('mousemove', enableScripts);
    window.addEventListener('keydown', enableScripts);
    window.addEventListener('touchstart', enableScripts);
    window.addEventListener('scroll', enableScripts, { passive: true });
  },

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },

  init() {
    const cookie = this.getCookie('OptanonConsent');

    if (cookie && cookie.includes('C0001%3A1')) {
      this.eagerLoadGtm();
    }

    this.startOnUserInteraction();
  },
};

export default enableExternalScripts;
